export default __webpack_public_path__ + "static/media/doctor-3.142698a0.jpg";